import { useAttachmentStoreFactory } from '@widgets/messenger/stores/useAttachmentStoreFactory'

export const useEmailAttachmentStore = useAttachmentStoreFactory(Symbol('emailAttachmentStore'))
